import { generateApiClient } from '@guiker/rest-client'

import { config } from '../config'
export {}
import { authenticatedApi } from '../api-definition'
export const authenticatedApiClient = generateApiClient(config.apiName, authenticatedApi.routes)
